module.exports = __webpack_public_path__ + "assets/img/lClass4.1cdc6aac.png";